<template>
	<div  class="my_wrapper"><!-- my_wrapper -->
	
	
		<div  class="my-header"><!-- my-header -->
			<div  class="my-head"><span></span></div>
			<div  class="my-name">{{userinfo.username}}</div>
		</div><!-- /my-header -->
		
		<ul  class="my-notice"><!-- my-notice -->
			<li>
				<h2 class="read"><i></i>阅读（次）</h2>
				<h3>{{yueduNum}}</h3>
			</li>
			<div class="vline"></div>
			<li>
				<h2 class="subscribe"><i></i>订阅（个）</h2>
				<h3>{{dingyueNum}}</h3>
			</li>
			<div class="vline"></div>
			<li>
				<h2 class="collection"><i></i>收藏（个）</h2>
				<h3>{{shoucangNum}}</h3>
			</li>
			<!-- <div class="vline"></div>
			<li>
				<h2 class="notice"><i></i>通知（次）</h2>
				<h3>200</h3>
			</li> -->
		</ul><!-- /my-notice -->
	
		
		
		<!-- <figure class="MyTabs Tabs1">
		  <ul class="MyTabs-tabs">
			<router-link to="/wode/zhanghu" tag="li" exact-active-class="active" class="MyTabs-tab"><a href="javascript:;">我的账户</a></router-link>
			<li class="MyTabs-tab"><a href="javascript:;"  >我的足迹</a></li>
			<router-link to="/wode/dingyue" tag="li" exact-active-class="active" class="MyTabs-tab"><a href="javascript:;">我的订阅</a></router-link>
			<li class="MyTabs-tab"><a href="javascript:;"  >我的收藏</a></li>
			<li class="MyTabs-tab"><a href="javascript:;"  >我的通知</a></li>
			<li class="MyTabs-tab"><a href="javascript:;"  >我的日志</a></li>
			<li class="MyTabs-tab"><a href="javascript:;"  >资料需求</a></li>
		  </ul>
		  <div class="MyTabs-content">
				<router-view/>
		  </div>
		</figure> -->
		
		<el-tabs v-model="wodeColum" @tab-click="wodeColumChange" :stretch="true">
			<el-tab-pane label="我的账户" name="zhanghu">
				<zhanghu v-bind:userinfo='userinfo'></zhanghu>
			</el-tab-pane>
			<el-tab-pane label="我的足迹" name="zuji">
				<zuji v-bind:userinfo='userinfo' @senddata="getYueduNum"></zuji>
			</el-tab-pane>
			<el-tab-pane label="我的订阅" name="dingyue">
				<dingyue @senddata="getDingyueNum"></dingyue>
			</el-tab-pane>
			<el-tab-pane label="我的收藏" name="shoucang">
				<shoucang v-bind:userinfo='userinfo' @senddata="getShoucangNum"></shoucang>
			</el-tab-pane>
			<!-- <el-tab-pane label="我的通知" name="tongzhi">我的通知</el-tab-pane>
			<el-tab-pane label="我的日志" name="rizhi">我的日志</el-tab-pane>
			<el-tab-pane label="资料需求" name="xuqiu">资料需求</el-tab-pane> -->
		</el-tabs>
		
		
		
	</div><!-- /my_wrapper -->
	
</template>

<script>
	import dingyue from '@/components/wode-dingyue.vue'
	import zhanghu from '@/components/wode-zhanghu.vue'
	import shoucang from '@/components/wode-shoucang.vue'
	import zuji from '@/components/wode-zuji.vue'
	export default {
		data() {
			return {
				wodeColum:'zhanghu',
				userinfo:'',
				yueduNum:0,
				dingyueNum:0,
				shoucangNum:0,
			}
		},
		components: {
			dingyue,
			zhanghu,
			shoucang,
			zuji,
		},
		created:function(){
			if(this.$route.params.seltype){
				this.wodeColum=this.$route.params.seltype;
			}
			this.userinfo=this.$cookies.get('userinfo');
		},
		mounted:function(){
			this.$track([
				['pagetype','我的']
			]);
		},
		computed: {

		},
		methods: {
			getYueduNum:function(count){
				this.yueduNum=count;
			},
			getDingyueNum:function(count){
				this.dingyueNum=count;
			},
			getShoucangNum:function(count){
				this.shoucangNum=count;
			},
			zhuantiColumChange: function() {
			
			},
		}
	}
</script>

<style>
	.my_wrapper .el-tabs__header{
		margin-bottom: 20px;
	}
	.my_wrapper .el-tabs__item {
		margin-bottom: 5px;
		font-size: 16px;
		font-weight: 600;
		color: #424656;
	}
	.my_wrapper .el-tabs__item.is-active {
		color: #bd1a2d;
	}
	.my_wrapper .el-tabs__active-bar{
		background-color: #bd1a2d;
	}
</style>
